module.exports = __webpack_public_path__ + "img/luckdraw.b918cde8.png";